import React from 'react';

const Color = () => {
  return (
    <div className="color">
      <div className="color_item">
        <div className="color_value" id="color-4"></div>
      </div>
      <div className="color_item">
        <div className="color_value" id="color-1"></div>
      </div>
      <div className="color_item">
        <div className="color_value" id="color-2"></div>
      </div>
      <div className="color_item">
        <div className="color_value" id="color-3"></div>
      </div>
    </div>
  );
};

export default Color;
